import { Flex, IconButton, Popover, Portal } from '@chakra-ui/react';

import FilterSectionContent from '@features/marketplace/navigation/FilterSectionContent';
import useControlledPopover from 'hooks/useControlledPopover';
import { FilterIcon } from 'vectors';

const FilterDropdown = () => {
  const { open, onToggle, triggerRef, contentRef } = useControlledPopover<
    HTMLDivElement,
    HTMLButtonElement
  >();

  return (
    <Popover.Root open={open} onOpenChange={onToggle} closeOnEscape unmountOnExit lazyMount>
      <Popover.Trigger asChild>
        <IconButton
          _hover={{
            backgroundColor: 'button.secondary.hover',
          }}
          ref={triggerRef}
          variant="ghost"
          px={2}
        >
          <Flex alignItems="center" flexDir="row" gap={2}>
            <FilterIcon />
          </Flex>
        </IconButton>
      </Popover.Trigger>
      <Portal>
        <Popover.Positioner>
          <Popover.Content borderRadius={8} ref={contentRef} bgColor="surface.background" p={2}>
            <FilterSectionContent />
          </Popover.Content>
        </Popover.Positioner>
      </Portal>
    </Popover.Root>
  );
};

export default FilterDropdown;
